module.exports = __webpack_public_path__ + "img/intermediateStep.dd06cec0.png";